<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<div>
    <h1>単価表登録</h1>
</div>
<!-- 詳細情報が取得できる場合表示 -->
<div *ngIf="showDetailflag">
    <form [formGroup]="tankatableDetailForm">
        <app-sgkc012d-tanka-table-basic-info [mode]="displayMode" [tankatableBasicInfo]="tankatableBasicInfo"
            id="basicinfo"></app-sgkc012d-tanka-table-basic-info>
        <div *ngIf="displayMode !== 'create'">
            <app-sgkc012d-tanka-table-approval-info [mode]="displayMode"
                [tankatableregistrationManageInfo]="tankatableregistrationManageInfo"
                id="approvalinfo"></app-sgkc012d-tanka-table-approval-info>
        </div>
        <app-sgkc012d-tanka-table-tanka-info [mode]="displayMode" [tankatableMeisaiList]="tankatableMeisaiList"
            (onClickRegistrationEvent)="onClickRegistration()" (onClickDeleteEvent)="onClickDelete()"
            (onClickApprovalEvent)="onClickApproval()"
            [tankatableregistrationManageInfo]="tankatableregistrationManageInfo"
            id="tankainfo"></app-sgkc012d-tanka-table-tanka-info>
    </form>
</div>